import hero from "../../assets/images/hero.png"
import useAuthStore from "../../store/authStore"
import { Button } from "../ui/button"
import { MoveRight } from "lucide-react"
import { useNavigate } from "react-router-dom"

export default function Hero () {
  const { user} = useAuthStore()
  const navigate = useNavigate()
  return (
    <div className="flex flex-col-reverse md:grid md:grid-cols-2  items-center">
      <div className="space-y-8  pl-16">
      <div className="text-[#DC5F00] font-bold text-md md:text-2xl">
        <h1>HỌC TIẾNG ANH</h1>
        <h1>THEO CÁCH ĐƠN GIẢN NHẤT</h1>

      </div>
      {user ?
       <Button className="rounded-full flex items-center gap-8 text-md md:text-xl py-6" onClick={() => navigate('/courses')}>
        Khám phá ngay
       <MoveRight />
     </Button>
      :
        <Button className="rounded-full flex items-center gap-8 text-md md:text-xl py-6" onClick={() => navigate('/register')}>
          Đăng ký ngay
          <MoveRight />
        </Button>
        }
      </div>

      <img src={hero} className="w-3/4 md:w-full h-auto" alt="hero-image"/>
    </div>
  )
}
